import type { PageContext } from 'vike/types';

/**
 * One collective agreement's page: logical /collective-agreements/{slug} (public /fi/tyoehtosopimus/{slug},
 * /sv/kollektivavtal/{slug}, /en/collective-agreements/{slug}). Lives outside pages/collective-agreements/
 * so it doesn't inherit the directory's +Head/+title (Vike configs are cumulative down a directory).
 * The slug may also be a Finlex id token ("2012-5"); +data.server.ts 301s that to the name slug.
 */
const PATTERN = /^\/collective-agreements\/([a-z0-9-]+)\/?$/;

export function route(pageContext: PageContext) {
  const raw = ((pageContext as { urlLogical?: string }).urlLogical ?? pageContext.urlPathname ?? '').split('?')[0];
  const m = raw.match(PATTERN);
  if (!m) return false;
  return { routeParams: { agreementSlug: m[1] } };
}
